import { CpOrderInvoicesSearchModel } from '../list/search/cp_order_invoices_search_types';
import { CpOrderInvoicesDataItem } from '../list/cp_order_invoices_list_types';
import { formatCpOrderInvoicesRequest } from '../list/search/formatCpOrderInvoicesRequest';
import apiSvc, { BinaryFileType } from '../../../core/services/apiSvc';
import utilSvc from '../../../core/utilSvc';
import { HttpErrorIgnore } from '../../../../global';
import { CP_ORDER_INVOICES_LIST_EXCEL_FILE_NAME } from '../cp_order_invoices_const';
import validSvc from '../../../core/validSvc';
import { InvoiceLineItemDispensesDataItem } from '../detail/invoice_line_item_dispenses_list_types';
import { ngDelegate } from '../../../core/services/ng.delegate';

export const GET_LIST = 'invoice/cp/list';
export const GET_EXCEL = 'invoice/cp/excel';
export const GET_LINE_ITEMS_EXCEL = 'invoice/cp/backing/excel';
const GET_DETAIL = 'invoice/split/detail';
const GET_BACKING_DISPENSES = 'invoice/cp/backing';
const TRUE_UP_LINE_ITEM = 'invoice/cp/trueup';

// Stubbed API call - replace with real implementation
const cpOrderInvoicesRepo = {
    async getList(query: CpOrderInvoicesSearchModel): Promise<CpOrderInvoicesDataItem[] | HttpErrorIgnore> {
        const params = formatCpOrderInvoicesRequest(query);

        try {
            const response = await apiSvc.getEntityList<CpOrderInvoicesDataItem>(GET_LIST, params);
            return response;
        } catch (err: any) {
            return utilSvc.http.ignore(err, 'cpOrderInvoicesRepo.getList') as HttpErrorIgnore;
        }
    },
    async getExcel(formValues: CpOrderInvoicesSearchModel): Promise<HttpErrorIgnore | undefined> {
        const fullFileName = `${CP_ORDER_INVOICES_LIST_EXCEL_FILE_NAME}_${formValues.StartDate?.val}-${formValues.EndDate?.val}`;
        const params = formatCpOrderInvoicesRequest(formValues);
        const filteredParams = { Context: (params as any).Context, Params: (params as any).Params };

        return apiSvc.postGetBinary(GET_EXCEL, filteredParams, fullFileName, BinaryFileType.Excel);
    },
    async getLineItemsExcel(
        lineId: string | undefined,
        invoiceId: string | undefined,
        rebates: boolean,
    ): Promise<HttpErrorIgnore | undefined> {
        if (!lineId) return undefined;
        const fullFileName = `CP-Invoice-${invoiceId}-Backing-Dispenses`;
        const filteredParams = { Context: {}, Params: { Id: lineId, RebatesOnly: rebates } };

        return apiSvc.postGetBinary(GET_LINE_ITEMS_EXCEL, filteredParams, fullFileName, BinaryFileType.Excel);
    },
    async getDetail(id: string): Promise<CpOrderInvoicesDataItem> {
        // params
        if (!validSvc.isText(id)) {
            throw new Error('cpOrderInvoicesRepo.getDetail, id is required');
        }

        return apiSvc.getEntity(GET_DETAIL, {
            Entity: {
                Params: {
                    Id: id,
                },
            },
        }) as unknown as CpOrderInvoicesDataItem;
    },
    async getLineItemDispenses(id: string): Promise<InvoiceLineItemDispensesDataItem[] | HttpErrorIgnore> {
        const params = {
            Params: { LineId: id },
        };

        try {
            const response = await apiSvc.getEntityList<InvoiceLineItemDispensesDataItem>(
                GET_BACKING_DISPENSES,
                params,
            );
            return response;
        } catch (err: any) {
            return utilSvc.http.ignore(err, 'cpOrderInvoicesRepo.getLineItemDispenses') as HttpErrorIgnore;
        }
    },
    async trueUpLineItem(id: string | undefined, notes: string): Promise<boolean | HttpErrorIgnore> {
        // params
        if (!!!id) {
            throw new Error('invoiceRepo.trueUpLineItem, id is required');
        }

        return apiSvc
            .post(TRUE_UP_LINE_ITEM, {
                Context: {},
                Params: {
                    Id: id,
                    Notes: notes,
                },
            })
            .then(
                () => {
                    ngDelegate.ok('TRUE UP CONFIRMED');
                    return true;
                },
                err => {
                    return utilSvc.http.ignore(err, 'cpOrderInvoicesRepo.trueUpLineItem') as HttpErrorIgnore;
                },
            );
    },
    // Add other repo methods as needed
};

export default cpOrderInvoicesRepo;
